import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { formatDateAtTime2, getCaseId, getClientId } from "../../Utils/helper";
import UserChatBubble from "../Forms/FirmUserBtn";
import { api_without_cancellation } from "../../api/api";
import useClientPage from "../new-client-dashboard/tabs/contact-panel/hooks/useClientPage";
import RecordingPlayerModal from "../new-client-dashboard/tabs/CallRecordingModal";
import NewRejectedIcon from "../../assets/NewRejectedIcon";
import NewPhoneIcon from "../../assets/NewPhoneIcon";

import VideoAudioPlayer from "./modals/video-audio-player";

const formatFileSize = (bytes) => {
  if (bytes === null || isNaN(bytes)) return "";
  if (bytes >= 1_048_576) return `${(bytes / 1_048_576).toFixed(1)} MB`;
  if (bytes >= 1_024) return `${(bytes / 1_024).toFixed(1)} KB`;
  return `${bytes} B`;
};

const formatDuration = (raw, abbreviated = false) => {
  if (!raw) return "";
  const [h, m, s] = raw.split(":").map(Number);
  const out = [];
  if (h) out.push(`${h} ${abbreviated ? "hr" : h === 1 ? "hour" : "hours"}`);
  if (m) out.push(`${m} ${abbreviated ? "min" : m === 1 ? "minute" : "minutes"}`);
  if (s || out.length === 0) {
    out.push(`${s} ${abbreviated ? "sec" : s === 1 ? "second" : "seconds"}`);
  }
  return out.join(" ");
};

const RecordingDuration = ({ value }) => (
  <>
    <span className="d-none d-xxl-inline">{formatDuration(value)}</span>
    <span className="d-inline d-xxl-none">{formatDuration(value, true)}</span>
  </>
);
// Function to render data rows
const renderDataRow2 = (
  trRef,
  tableRowStyle,
  doc,
  index,
  userOnlineStatus,
  handleRecordingSelection
) => (
  <tr
    ref={trRef}
    key={`defendant-${index}`}
    className="defendant-height-205"
    onClick={() => handleRecordingSelection(doc)}
    style={tableRowStyle}
  >
    <td
      className="text-center"
      style={{
        minWidth: "25px",
        width: "25px",
        maxWidth: "25px",
        color: "var(--primary-25)",
        fontWeight: "600",
      }}
    >
      {index + 1}
    </td>
    <td className="td-autosize p-l-5">
      <div className="d-flex p-l-5 height-21 align-items-center">
        {doc.call_status === "no_answer" ? <NewRejectedIcon /> : <NewPhoneIcon />}
        <span
          className="p-l-5 height-21 d-flex file-name-recorded align-items-center"
          style={{
            fontWeight: "600",
            gap: "5px",
          }}
        >
          {doc?.name}
        </span>
        <span
          className="p-l-5"
          style={{
            fontWeight: "600",
            gap: "5px",
          }}
        >
          {doc?.ext ?? ".mp3"} initiated by
        </span>
        <span className="p-l-5">
          {doc?.initiated_by?.client_id ? (
            <>
              <div className="d-flex align-items-center">
                <div
                  className="image-container-modal d-flex align-items-center justify-content-center"
                  style={{
                    width: "19px",
                    height: "19px",
                  }}
                >
                  <img
                    src={doc?.initiated_by?.profile_pic_19p}
                    alt={""}
                    style={{
                      width: "19px",
                      height: "19px",
                    }}
                  />
                  {/* <div className="border-overlay-modal" /> */}
                </div>
                <p
                  className="ps-1"
                  style={{
                    fontSize: "14px",
                  }}
                >
                  {doc?.initiated_by?.first_name} {doc?.initiated_by?.last_name}
                </p>
              </div>
            </>
          ) : (
            <UserChatBubble
              userId={doc?.initiated_by?.id}
              first_name={doc?.initiated_by?.first_name ?? ""}
              last_name={doc?.initiated_by?.last_name ?? ""}
              profilePic={doc?.initiated_by?.profile_pic_29p ?? ""}
              is_active={doc?.initiated_by?.is_active}
              width={19}
              height={25}
              isActive={userOnlineStatus?.[doc?.initiated_by?.id]?.isOnline ?? false}
            />
          )}
        </span>
      </div>
    </td>
    <td />
    <td>
      <div className="d-flex p-l-5 height-21 align-items-center justify-content-end">
        <span
          className="height-21 d-flex align-items-center justify-content-end"
          style={{
            fontWeight: "600",
            gap: "5px",
          }}
        >
          <RecordingDuration value={doc?.duration} />
        </span>
      </div>
    </td>
    <td />
    <td>
      <div
        style={{
          fontWeight: "600",
          textTransform: "lowercase",
        }}
        className="d-flex align-items-center text-center justify-content-end"
      >
        {formatFileSize(doc?.size)}
      </div>
    </td>

    <td />
    <td>
      <div className="d-flex align-items-center p-l-5" title={doc?.description || ""}>
        {doc?.description || ""}
      </div>
    </td>
    <td />
    <td className="text-end">
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          gap: "5px",
        }}
      >
        <div
          style={{
            fontWeight: "600",
          }}
          className="d-flex flex-column time-name-recorded justify-content-end"
        >
          {formatDateAtTime2(doc?.created_at)}
        </div>
        {/* <div className="border-overlay-modal" /> */}
        {/* <div
          style={{
            fontWeight: "600",
          }}
          className="d-flex flex-column align-items-center"
        >
          {doc?.initiated_by?.client_id ? (
            <>
              <div className="d-flex align-items-center">
                <div
                  className="image-container-modal d-flex align-items-center justify-content-center"
                  style={{
                    width: "19px",
                    height: "19px",
                  }}
                >
                  <img
                    src={doc?.initiated_by?.profile_pic_19p}
                    alt={""}
                    style={{
                      width: "19px",
                      height: "19px",
                    }}
                  />
                </div>
                <p
                  className="ps-1"
                  style={{
                    fontSize: "14px",
                  }}
                >
                  {doc?.initiated_by?.first_name} {doc?.initiated_by?.last_name}
                </p>
              </div>
            </>
          ) : (
            <UserChatBubble
              first_name={doc?.initiated_by?.first_name ?? ""}
              last_name={doc?.initiated_by?.last_name ?? ""}
              profilePic={doc?.initiated_by?.profile_pic_29p ?? ""}
              is_active={doc?.initiated_by?.is_active}
              width={19}
              height={25}
              isActive={userOnlineStatus?.[doc?.initiated_by?.id]?.isOnline ?? false}
            />
          )}
        </div> */}
      </div>
    </td>

    <td />
  </tr>
);
const renderDataRow = (
  trRef,
  tableRowStyle,
  doc,
  index,
  userOnlineStatus,
  handleRecordingSelection
) => (
  <tr
    ref={trRef}
    key={`defendant-${index}`}
    className="defendant-height-205"
    onClick={() => handleRecordingSelection(doc)}
    style={tableRowStyle}
  >
    <td
      className="text-center"
      style={{
        minWidth: "25px",
        width: "25px",
        maxWidth: "25px",
        color: "var(--primary-25)",
        fontWeight: "600",
      }}
    >
      {index + 1}
    </td>
    <td className="td-autosize p-l-5">
      <div className="d-flex p-l-5 height-21 align-items-center">
        <span
          className="height-21 file-name-recorded d-flex align-items-center"
          style={{
            fontWeight: "600",
            gap: "5px",
          }}
        >
          {doc?.original_filename}
        </span>
        <span
          className="p-l-5"
          style={{
            fontWeight: "600",
            gap: "5px",
          }}
        >
          {doc?.ext}
        </span>
      </div>
    </td>
    <td />
    <td>
      <div className="d-flex p-l-5 height-21 align-items-center justify-content-end">
        <span
          className="height-21 d-flex align-items-center justify-content-end"
          style={{
            fontWeight: "600",
            gap: "5px",
          }}
        >
          <RecordingDuration value={doc?.duration} />
        </span>
      </div>
    </td>
    <td />
    <td>
      <div
        style={{
          fontWeight: "600",
          textTransform: "lowercase",
        }}
        className="d-flex align-items-center text-center justify-content-end"
      >
        {doc?.file_size}
      </div>
    </td>

    <td />
    <td>
      <div
        style={{
          fontWeight: "600",
        }}
        className="d-flex align-items-center p-l-5"
        title={doc?.description || ""}
      >
        {doc?.description || ""}
      </div>
    </td>
    <td />
    <td className="text-end">
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          gap: "10px",
        }}
      >
        <div
          style={{
            fontWeight: "600",
          }}
          className="d-flex flex-column time-name-recorded justify-content-end"
        >
          {formatDateAtTime2(doc?.created_at)}
        </div>
        <div
          style={{
            fontWeight: "600",
          }}
          className="d-flex flex-column align-items-center"
        >
          <UserChatBubble
            userId={doc?.uploaded_by?.id}
            first_name={doc?.uploaded_by?.first_name ?? ""}
            last_name={doc?.uploaded_by?.last_name ?? ""}
            profilePic={doc?.uploaded_by?.profile_pic_29p ?? ""}
            is_active={doc?.uploaded_by?.is_active}
            width={19}
            height={25}
            isActive={userOnlineStatus?.[doc?.uploaded_by?.id]?.isOnline ?? false}
          />
        </div>
      </div>
    </td>

    <td />
  </tr>
);

const renderEmptyRows = (emptyRowStyle, tableRowStyle, dataLength, fakeRows) => {
  const minRows = fakeRows;
  const emptyRowsCount = Math.max(0, minRows);

  return Array.from({ length: emptyRowsCount }, (_, index) => (
    <tr key={`empty-${index}`} style={tableRowStyle}>
      <td colSpan={14} className="empty-row height-25">
        <div style={emptyRowStyle}>{/* Empty row */}</div>
      </td>
    </tr>
  ));
};

function VideoAudioRecordingView({ doc = [], containerHeight, refetchData }) {
  const [lineHeight, setLineHeight] = React.useState(25);
  const [recordingModalOpen, setRecordingModalOpen] = useState(false);
  const [selectedRecordingCall, setSelectedRecordingCall] = useState(null);
  const [deletingRecording, setDeletingRecording] = useState(false);
  const [deleteError, setDeleteError] = useState(null);
  const [savingDescription, setSavingDescription] = useState(false);
  const [descriptionError, setDescriptionError] = useState(null);

  const [recordingModalOpen2, setRecordingModalOpen2] = useState(false);
  const [selectedRecordingCall2, setSelectedRecordingCall2] = useState(null);

  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);
  const tableRowStyle = {
    height: `${lineHeight}px`,
    lineHeight: `${lineHeight}px`,
  };

  const emptyRowStyle = {
    height: `${lineHeight}px`,
    width: "100%",
  };
  const trRef = useRef(null);
  const [fakeRows, setFakeRows] = useState(0);

  const handleRecordingSelection = (obj) => {
    setSelectedRecordingCall(obj);
    setDeleteError(null);
    setRecordingModalOpen(true);
  };

  const handleCloseRecordingModal = () => {
    setRecordingModalOpen(false);
    setDeleteError(null);
    setDescriptionError(null);
  };

  const handleSaveDescription = async (description) => {
    if (!selectedRecordingCall?.id || savingDescription) return;

    try {
      setSavingDescription(true);
      setDescriptionError(null);
      const response = await api_without_cancellation.patch(
        `/api/recordings/${getClientId()}/${getCaseId()}/${selectedRecordingCall.id}/`,
        { description }
      );

      setSelectedRecordingCall((current) => ({
        ...current,
        ...(response.data || {}),
        description,
      }));
      await refetchData?.();
      setRecordingModalOpen(false);
      setSelectedRecordingCall(null);
    } catch (error) {
      setDescriptionError(
        error.response?.data?.description?.[0] ||
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "Failed to update description."
      );
      console.error(error);
      throw error;
    } finally {
      setSavingDescription(false);
    }
  };

  const handleDeleteRecording = async () => {
    if (!selectedRecordingCall?.id || deletingRecording) return;

    const formData = new FormData();
    formData.append("id", selectedRecordingCall.id);

    try {
      setDeletingRecording(true);
      setDeleteError(null);
      const response = await api_without_cancellation.delete(
        `/api/recordings/${getClientId()}/${getCaseId()}/`,
        {
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.status !== 204) {
        setDeleteError("Failed to delete recording.");
        return;
      }

      setRecordingModalOpen(false);
      setSelectedRecordingCall(null);
      await refetchData?.();
    } catch (error) {
      setDeleteError(
        error.response?.data?.message ||
          error.response?.data?.detail ||
          "Failed to delete recording."
      );
      console.error(error);
    } finally {
      setDeletingRecording(false);
    }
  };

  const handleRecordingSelection2 = (obj) => {
    setSelectedRecordingCall2(obj);
    setRecordingModalOpen2(true);
  };

  useEffect(() => {
    if (!containerHeight?.current) return;

    const height = containerHeight.current.offsetHeight;
    const availableHeight = height - 80;

    const minHeight = 25;
    const totalRows = Math.floor(availableHeight / minHeight);

    const availableRows = doc?.results?.length || 0;
    const fake = totalRows - availableRows;

    setFakeRows(fake);
  }, [containerHeight, doc?.results?.length]);

  useEffect(() => {
    if (trRef.current) {
      setLineHeight(trRef.current.offsetHeight);
    }
  }, []);

  const adjustReportColumnWidths = () => {
    const pinColumn = (selector) => {
      const cols = document.querySelectorAll(selector);
      if (!cols.length) return;
      let maxWidth = 0;
      cols.forEach((col) => {
        maxWidth = Math.max(maxWidth, col.getBoundingClientRect().width);
      });
      cols.forEach((col) => {
        col.style.width = `${maxWidth}px`;
        col.style.minWidth = `${maxWidth}px`;
        col.style.maxWidth = `${maxWidth}px`;
      });
    };

    pinColumn(".file-name-recorded");
    pinColumn(".time-name-recorded");
  };

  useEffect(() => {
    adjustReportColumnWidths();
    window.addEventListener("resize", adjustReportColumnWidths);
    return () => window.removeEventListener("resize", adjustReportColumnWidths);
  }, [doc]);

  const { clientData } = useClientPage(getClientId(), getCaseId());

  const fetchRecording = async (callId) => {
    const response = await api_without_cancellation.get(
      `/api/client-page/client-communication/calls/${callId}/recording/`,
      { responseType: "arraybuffer" }
    );
    return response;
  };
  return (
    <div className="custom-tab lit-custom-tab w-100 m-b-5">
      {/* Table */}
      <div className="table-responsive overflow-hidden">
        <table className="table table-borderless table-striped table-treatment has-height-25">
          <thead>
            <tr id="tb-header">
              <th
                className="text-center"
                style={{
                  minWidth: "25px",
                  width: "25px",
                  maxWidth: "25px",
                }}
              />

              <th className="td-autosize text-center color-grey-2 p-l-5 recording-col">
                Recording
              </th>
              <th />
              <th className="td-autosize text-center color-grey-2 p-l-5 length-col">length</th>
              <th />
              <th className="td-autosize text-center color-grey-2 size-col">Size</th>
              <th />
              <th className="td-autosize text-center color-grey-2 description-col">Description</th>
              <th />
              <th className="td-autosize text-center color-grey-2 added-col">Added</th>
              <th
                style={{
                  minWidth: "5px",
                  maxWidth: "5px",
                  width: "5px",
                }}
              />
            </tr>
          </thead>
          <tbody>
            {doc?.results?.map((doc1, index) => {
              if (doc1?.type === "call") {
                return renderDataRow2(
                  trRef,
                  tableRowStyle,
                  doc1,
                  index,
                  userOnlineStatus,
                  handleRecordingSelection2
                );
              }
              return renderDataRow(
                trRef,
                tableRowStyle,
                doc1,
                index,
                userOnlineStatus,
                handleRecordingSelection
              );
            })}
            {renderEmptyRows(emptyRowStyle, tableRowStyle, doc?.results?.length || 0, fakeRows)}
          </tbody>
        </table>
      </div>
      {recordingModalOpen && (
        <VideoAudioPlayer
          show={recordingModalOpen}
          onClose={handleCloseRecordingModal}
          onDelete={handleDeleteRecording}
          deleting={deletingRecording}
          deleteError={deleteError}
          onSaveDescription={handleSaveDescription}
          savingDescription={savingDescription}
          descriptionError={descriptionError}
          selectedRecording={selectedRecordingCall}
        />
      )}

      {recordingModalOpen2 && (
        <RecordingPlayerModal
          show={recordingModalOpen2}
          onClose={() => setRecordingModalOpen2(false)}
          callData={selectedRecordingCall2}
          fetchRecording={fetchRecording}
          clientData={clientData}
          onDescriptionSaved={refetchData}
        />
      )}
    </div>
  );
}

export default React.memo(VideoAudioRecordingView);
